/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Fantasy Points scoring works`)
};

const es_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona la puntuación de Fantasy Points`)
};

const de_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie die Fantasy-Punkte-Wertung funktioniert`)
};

const nl_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe Fantasy Points-scoring werkt`)
};

const fr_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionne le scoring Fantasy Points`)
};

const it_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona il punteggio Fantasy Points`)
};

const pt_br2_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona a pontuação de Fantasy Points`)
};

const pt_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona a pontuação de Fantasy Points`)
};

const ja_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファンタジーポイントのスコアリング方法`)
};

const zh_f1_points_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梦幻积分计分方式`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_how_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_how_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_how_title", locale)
	if (locale === "en") return en_f1_points_how_title(inputs)
	if (locale === "es") return es_f1_points_how_title(inputs)
	if (locale === "de") return de_f1_points_how_title(inputs)
	if (locale === "nl") return nl_f1_points_how_title(inputs)
	if (locale === "fr") return fr_f1_points_how_title(inputs)
	if (locale === "it") return it_f1_points_how_title(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_how_title(inputs)
	if (locale === "pt") return pt_f1_points_how_title(inputs)
	if (locale === "ja") return ja_f1_points_how_title(inputs)
	return zh_f1_points_how_title(inputs)
};